import CustomerProfile from "./customerProfile"
export default CustomerProfile;
